// แปลงจำนวนเงิน (บาท) เป็นคำอ่านภาษาไทย เช่น 4601 → "สี่พันหกร้อยเอ็ดบาทถ้วน"
// ใช้กับใบเสร็จ/ใบกำกับภาษี/ใบแจ้งหนี้/ใบเสนอราคา — เขียนแยกไว้ที่นี่ให้ใช้ซ้ำได้ทุกเอกสาร

const DIGITS = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า']
const POSITIONS = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน']

// แปลงจำนวนเต็ม (ไม่มีจุดทศนิยม) ที่ไม่เกิน 6 หลักต่อ "ช่วงล้าน" ให้เป็นคำอ่าน — เรียกซ้ำเป็นช่วงล้านสำหรับตัวเลขที่ใหญ่กว่านั้น
function readInteger(numStr: string): string {
  if (numStr === '0') return DIGITS[0]

  // ตัดเป็นช่วงละ 6 หลักจากท้าย (หลักล้าน) แล้วอ่านทีละช่วง ต่อด้วยคำว่า "ล้าน" คั่นระหว่างช่วง
  const chunks: string[] = []
  let rest = numStr
  while (rest.length > 6) {
    chunks.unshift(rest.slice(-6))
    rest = rest.slice(0, -6)
  }
  chunks.unshift(rest)

  return chunks.map((chunk, i) => readChunk(chunk, i < chunks.length - 1)).join('')
}

// อ่านตัวเลข ≤ 6 หลัก — isMillionChunk: ช่วงนี้ไม่ใช่ช่วงสุดท้าย ต้องต่อท้ายด้วย "ล้าน" เสมอแม้เป็น 0 (เช่น 1,000,000 → "หนึ่งล้าน")
function readChunk(chunk: string, isMillionChunk: boolean): string {
  const digits = chunk.split('').map(Number)
  const len = digits.length
  let result = ''

  for (let i = 0; i < len; i++) {
    const digit = digits[i]
    const position = len - i - 1   // 0=หลักหน่วย, 1=สิบ, 2=ร้อย, ...
    if (digit === 0) continue
    if (position === 0) {
      // หลักหน่วย: "เอ็ด" แทน "หนึ่ง" เมื่อมีหลักสิบขึ้นไปนำหน้า (เช่น 21 → ยี่สิบเอ็ด, 1 → หนึ่ง)
      result += digit === 1 && len > 1 ? 'เอ็ด' : DIGITS[digit]
    } else if (position === 1) {
      // หลักสิบ: "ยี่สิบ" ไม่ใช่ "สองสิบ", ตัด "หนึ่ง" ออกจาก "หนึ่งสิบ" → "สิบ"
      result += digit === 1 ? POSITIONS[1] : digit === 2 ? `ยี่${POSITIONS[1]}` : `${DIGITS[digit]}${POSITIONS[1]}`
    } else {
      result += `${DIGITS[digit]}${POSITIONS[position] ?? ''}`
    }
  }
  return result + (isMillionChunk ? 'ล้าน' : '')
}

export function thaiBahtText(amount: number): string {
  if (!Number.isFinite(amount) || amount < 0) return ''
  const rounded = Math.round(amount * 100) / 100
  const baht = Math.floor(rounded)
  const satang = Math.round((rounded - baht) * 100)

  const bahtText = `${readInteger(String(baht))}บาท`
  if (satang === 0) return `${bahtText}ถ้วน`
  return `${bahtText}${readInteger(String(satang))}สตางค์`
}
